import { type ReactNode } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { SupportUsPopover } from '@/components/common/SupportUs'
import { type CardIdType } from '@/defs/card'
import { useModal } from '@/hooks/useModal'
import { cn } from '@/utils/commonUtil'

import { CardArtModal } from '../CardArtModal/CardArtModal'
import { useCardArtChooser } from '../hooks/useCardArtChooser'

type Props = {
  cardId: CardIdType
  children: ReactNode
  className?: string
  classNameDisabled?: string
}

export const CardButtonArt = ({ cardId, children, className, classNameDisabled }: Props) => {
  const { open } = useModal(`card-art-${cardId}`)
  const { hasOptions, isEnabled } = useCardArtChooser(cardId)

  if (!hasOptions) return null

  const onClick = () => {
    open({ content: <CardArtModal cardId={cardId} />, disablePointerEvents: true, variant: 'nobox' })
  }

  if (isEnabled) {
    return (
      <ButtonRoot aria-label='Change Card Art' className={className} onClick={onClick} title='Change Card Art'>
        {children}
      </ButtonRoot>
    )
  }

  return (
    <SupportUsPopover
      aria-label='Change Card Art'
      className={cn(className, classNameDisabled)}
      message='Unlock the preferred card art chooser by joining our Patreon for only $5/month.'
      title='Change Card Art'
      utm={{ medium: 'art_chooser' }}
    >
      {children}
    </SupportUsPopover>
  )
}
